import MarketplaceItemVariantsData from './MarketplaceItemVariantsData'

export default MarketplaceItemVariantsData
